<template>

    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" :class="showToggled ? 'toggled' : ''"
        id="accordionSidebar">
        
        <a class="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
            <div class="sidebar-brand-text mx-3">
                <LogoNegative formatting="logo-center" width="135px"></LogoNegative>
            </div>
        </a>
        <hr class="sidebar-divider my-0">
        <li class="nav-item active">
            <router-link class="nav-link" to="/" :class="route == '/' ? 'active' : ''">
                <i class="fas fa-fw fa-home"></i>
                <span>Início</span></router-link>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseRegistrations"
                aria-expanded="true" aria-controls="collapseRegistrations">
                <i class="fas fa-fw fa-plus"></i>
                <span>Cadastros</span>
            </a>
            <div id="collapseRegistrations" class="collapse collapse_menu" aria-labelledby="headingTwo"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'category' ? 'active' : ''" to="/category"
                        @click="itemSelectec('category')">Categorias</router-link>
                    <router-link class="collapse-item" :class="route == 'service' ? 'active' : ''" to="/service"
                        @click="itemSelectec('service')">Serviços</router-link>
                    <router-link class="collapse-item" :class="route == 'supplier' ? 'active' : ''" to="/supplier"
                        @click="itemSelectec('supplier')">Fornecedores</router-link>
                    <router-link class="collapse-item" :class="route == 'client' ? 'active' : ''" to="/client"
                        @click="itemSelectec('client')">Clientes</router-link>
                    <router-link class="collapse-item" :class="route == 'lead' ? 'active' : ''" to="/lead"
                        @click="itemSelectec('lead')">Leads</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseFinancial"
                aria-expanded="true" aria-controls="collapseFinancial">
                <i class="fas fa-fw fa-money-bill"></i>
                <span>Financeiro</span>
            </a>
            <div id="collapseFinancial" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'bank-account' ? 'active' : ''"
                        to="/bank-account" @click="itemSelectec('bank-account')">Contas bancárias</router-link>
                    <router-link class="collapse-item" :class="route == 'receivable-account' ? 'active' : ''"
                        to="/receivable-account" @click="itemSelectec('receivable-account')">Receitas</router-link>
                    <router-link class="collapse-item" :class="route == 'payable-account' ? 'active' : ''"
                        to="/payable-account" @click="itemSelectec('payable-account')">Despesas</router-link>
                    <router-link class="collapse-item" :class="route == 'dashboard-financial' ? 'active' : ''"
                        to="/dashboard-financial" @click="itemSelectec('dashboard-financial')">Resumo Financeiro</router-link>
                </div>
            </div>
        </li>
        <!--
        <hr class="sidebar-divider">
         <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseReport"
                aria-expanded="true" aria-controls="collapseReport">
                <i class="fas fa-fw fa-file-pdf"></i>
                <span>Relatórios</span>
            </a>
            <div id="collapseReport" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                     <router-link class="collapse-item" :class="route == 'bank-account' ? 'active' : ''" to="/bank-account"
                        @click="itemSelectec('bank-account')">Contas bancárias</router-link>
                    <a class="collapse-item" href="login.html">Contas a pagar</a>
                    <a class="collapse-item" href="register.html">Contas a receber</a>
                </div>
            </div>
        </li>   -->
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseActivity"
                aria-expanded="true" aria-controls="collapseActivity">
                <i class="fas fa-calendar"></i>
                <span>Atividades</span>
            </a>
            <div id="collapseActivity" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'activity' ? 'active' : ''" to="/activity"
                        @click="itemSelectec('activity')">Equipe</router-link>
                    <router-link class="collapse-item" :class="route == 'activity-statistic' ? 'active' : ''"
                        to="/activity-statistic" @click="itemSelectec('activity-statistic')">Estatísticas</router-link>
                </div>
            </div>
        </li>

        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseConfig"
                aria-expanded="true" aria-controls="collapseConfig">
                <i class="fas fa-fw fa-cog"></i>
                <span>Configurações</span>
            </a>
            <div id="collapseConfig" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'user' ? 'active' : ''" to="/user"
                        @click="itemSelectec('user')">Usuários</router-link>
                    <router-link class="collapse-item" :class="route == 'role' ? 'active' : ''" to="/role"
                        @click="itemSelectec('role')">Perfil de acesso</router-link>
                    <router-link class="collapse-item" :class="route == 'mirror-directory' ? 'active' : ''"
                        to="/mirror-directory" @click="itemSelectec('mirror-directory')">Diretórios
                        espelho</router-link>
                    <router-link class="collapse-item" :class="route == 'general-configuration' ? 'active' : ''"
                        to="/general-configuration" @click="itemSelectec('general-configuration')">Geral</router-link>
                    <router-link class="collapse-item" :class="route == 'log' ? 'active' : ''" to="/log"
                        @click="itemSelectec('log')">Logs</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseProfile"
                aria-expanded="true" aria-controls="collapseProfile">
                <i class="fas fa-fw fa-user"></i>
                <span>Perfil</span>
            </a>
            <div id="collapseProfile" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">

                    <a class="collapse-item" href="#" @click="logout()">Sair</a>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider d-none d-md-block">

        <div class="text-center d-none d-md-inline">
            <button class="rounded-circle border-0" id="sidebarToggle" @click="showHideMenu"></button>
        </div>
    </ul>
</template>

<script>
import api from '@/api';
import LogoNegative from '../img/logo-negative.vue';
import { menu } from '../../menu.js'

export default {
    components: { LogoNegative },
    data() {
        return {
            toggled: true,
            route: ''
        }
    },

    computed: {
        showToggled: function () {
            return !menu.toggled;
        }
    },

    mounted() {
        this.toggled = !menu.toggled;
    },

    methods: {
        itemSelectec(item) {
            this.route = item;
            const collapse = document.querySelectorAll('.collapse_menu');
            collapse.forEach(div => {
                div.className = "";
                div.className = "collapse collapse_menu";
            });
        },
        showHideMenu() {
            menu.changeToggled();
        },
        logout() {
            api.post('/auth/logout')
                .then(() => {
                    this.$notify({
                        title: "Sucesso",
                        text: "Sessão encerrada com sucesso!",
                        type: 'success'
                    });
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    localStorage.removeItem('email');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    localStorage.removeItem('expire_in');
                    localStorage.removeItem('change_password');
                    localStorage.removeItem('two_authentication_factor');

                    this.$router.push('/login');
                }).catch(error => {
                    if (error.status == 401) {
                        this.$notify({
                            title: "Falha",
                            text: "Sessão já encerrada!",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    } else if (error.status == 429) {
                        this.$notify({
                            title: "Falha",
                            text: "Foram realizadas várias tentativas de finalização de sessão! Aguarde alguns instantes e tente novamente!",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    } else if (error.status == 500) {
                        this.$notify({
                            title: "Falha",
                            text: "Não foi possível encerrar a sessão! Por gentileza, contacte o suporte técnico para mais detalhes",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    }

                })
        },
    }
}
</script>

<style>
.active {
    font-weight: bold;
}
</style>